<template>
  <transition name="ae-fade">
    <div
      v-show="showSubtitles"
      class="wt-sot-subtitles-placeholder"
      :aspect-ratio="story.aspectRatio.name"
    >
      The subtitles will appear here
    </div>
  </transition>
</template>

<script>
/** (GW)
 * Asset Editor's subtitles stage vue
 */
import 'app';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('assetEditor', ['tmpAGD', 'workModel', 'story']),
    ...mapGetters('assetEditor', ['currentPage']),

    showSubtitles: function () {
      return this.currentPage.id === 'subtitles'
        ? this.tmpAGD._showSubtitles
        : !!this.workModel.agd.videoQuoteSubTitles;
    },
  },

  methods: {
    ...mapActions('assetEditor', ['track']),
  },

  mounted: function () {
    this.track({ e: 'selectedSubtitles' });
  },
};
</script>
